import axiosInstance from "./axiosInstance.ts";

export const getCategories = async () => {
    const response = await axiosInstance.get("/events/category");
    return response.data;
}
